import styles from './PaymentPlanSelection.module.scss';

import React from 'react';
import { useTranslation } from 'react-i18next';
import { TextV2 } from 'components/TextV2/TextV2';
import { stringFormatForTestAttr } from 'utils/StringFormatForTest';
import { Installments, Plan } from 'components/Cart/OrderSummary/types';
import { PLAN_SELECT_TEST_ID } from './PaymentPlanSelection.const';
import { useCheckout } from 'components/Checkout/CheckoutProvider';

interface IPaymentPlanSelectionProps extends React.InputHTMLAttributes<HTMLInputElement> {
  id: string;
  plan: Plan;
}

export const PaymentPlanSelection: React.FC<IPaymentPlanSelectionProps> = ({ id, plan, ...props }) => {
  const { t } = useTranslation();
  const { setSelectedPurchaseType } = useCheckout();

  const tabEnterKey = (e: React.KeyboardEvent<HTMLHeadingElement>) => {
    if (e.key === 'Enter') {
      setSelectedPurchaseType(plan.term);
    }
  };

  let text;

  const dataTestIdPlan = `${stringFormatForTestAttr(plan.term)}-plan`;

  switch (plan.term) {
    case Installments.SL36:
      text = t('order-summary.36-month-installment-title');
      break;
    case Installments.SL48:
      text = t('order-summary.48-month-installment-title');
      break;
  }

  return (
    <label data-testid={dataTestIdPlan} id={id}>
      <input type="radio" value={plan.term} name="plan-select" className={styles.input} {...props} />

      <h5 className={styles.text} tabIndex={0} onKeyDown={e => tabEnterKey(e)}>
        <TextV2 tagName="span" variant="body" value={text} data-testid={PLAN_SELECT_TEST_ID.text} />

        <TextV2
          tagName="span"
          variant="body"
          value={t('order-summary.monthly-price', { price: plan.price })}
          data-testid={PLAN_SELECT_TEST_ID.price}
        />
      </h5>
    </label>
  );
};

PaymentPlanSelection.displayName = 'PaymentPlanSelection';
